import { useState } from 'react';

interface ColorProps {
  color: {
    id: number;
    number: string;
    name: string;
    image: string;
    price: string;
    collection: string;
  };
}

export default function ColorCard({ color }: ColorProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  return (
    <div className="group cursor-pointer">
      <div className="relative rounded-lg overflow-hidden aspect-square mb-3 bg-stone-50 shadow-sm hover:shadow-lg transition-all duration-300">
        {!imageLoaded && !imageError && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="w-8 h-8 border-3 border-stone-200 border-t-stone-400 rounded-full animate-spin"></div>
          </div>
        )}
        {imageError && (
          <div className="absolute inset-0 flex flex-col items-center justify-center text-stone-400">
            <i className="ri-image-line text-3xl w-10 h-10 flex items-center justify-center mb-2"></i>
            <span className="text-xs">No disponible</span>
          </div>
        )}
        <img
          src={color.image}
          alt={color.name}
          className={`w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500 ${
            imageLoaded ? 'opacity-100' : 'opacity-0'
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => setImageError(true)}
          loading="lazy"
        />
        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300"></div>
        <div className="absolute top-2 left-2">
          <span className="bg-white/90 backdrop-blur-sm text-stone-700 text-[11px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            {color.collection}
          </span>
        </div>
      </div>
      <h3 className="text-xs font-medium text-stone-900 group-hover:text-stone-600 transition-colors leading-tight mb-1">
        {color.name}
      </h3>
      <p className="text-xs text-stone-500">{color.price}</p>
    </div>
  );
}
